import {mapActions, mapGetters, mapMutations} from 'vuex'
import {FETCH_PAYMENTS_SYSTEM, POPUP_BUY_IFRAME, REPLENIST_BALANCE} from '@/store/mutation-types';
import store from "@/store";
import CryptoPaymentPopup from '@/components/popup-crypto-pay/index.vue'
import GCFPaymentPopup from '@/components/popup-gcf-pay/GCFPaymentPopup.vue' // Добавляем импорт GCF компонента
import axios from 'axios' // Добавляем импорт axios

export default {
  name: 'top-up-wallet',
  components: {
    CryptoPaymentPopup,
    GCFPaymentPopup // Регистрируем компонент GCFPaymentPopup
  },
  data() {
    return {
      value: '',
      paySystem: null,
      isFutureFund: this.$route.name === 'personal.future_top_up_wallet',
      payload: {
        payment_system: null,
        amount: 0,
        type: 'refill_wallet'
      },
      showCryptoPopup: false,
      showGCFPopup: false, // Добавляем флаг для отображения GCF попапа
      gcfPaymentData: null, // Добавляем данные для GCF платежа
      maxAmounts: {
        BetaTransferCrypto: 5000,
        BetaTransferUkraine: 405,
        BetaTransferAZN: 2835,
        BetaTransferKZT: 400,
        GCFPay: 5000 // Добавляем лимит для GCFPay
      },
      minAmounts: {
        BetaTransferCrypto: 5,
        BetaTransferUkraine: 10,
        BetaTransferAZN: 10,
        BetaTransferKZT: 10,
        GCFPay: 10 // Добавляем минимальную сумму для GCFPay
      }
    }
  },
  mounted() {
    this.fetchUser().then(() => {
      this.setUuidAsync(this.fetchUserData.uuid)
    })
  },
  computed: {
    ...mapGetters({
      payments: `profileBuyTree/payments`,
      setting: 'main/setting',
      isLoadingCountryCode: 'main/isLoadingCountryCode',
      fetchUserData: `profile/user`,
      user: `profile/user`, // Добавляем доступ к пользователю
      gcfLoading: 'gcf_store/isLoading', // Добавляем индикатор загрузки GCF
      gcfError: 'gcf_store/getError', // Добавляем информацию об ошибках GCF
    }),
    ...mapGetters('new_user',{
      uuid: "uuid",
    }),
    preparePayments(){
      if (!this.payments){
        return [];
      }
      return [
        ...this.payments,
        {
          payment_system: "BetaTransferCrypto",
          restriction: null
        },
        // {
        //   payment_system: "BetaTransferUkraine",
        //   restriction: null
        // },
        // {
        //   payment_system: "BetaTransferAZN",
        //   restriction: null
        // },
        // {
        //   payment_system: "BetaTransferKZT",
        //   restriction: null
        // },
        {
          payment_system: "GCFPay", // Добавляем GCFPay
          restriction: null
        }
      ]
    },
    watchField() {
      if (this.value !== 0 && this.value !== '' && this.paySystem !== null) {
        return true
      } else {
        return false
      }
    },
    countTress() {
      return Math.round(((this.payload.amount * this.setting.futuresMultiplier).toFixed(3) / this.setting.futuresPrice) * 100) / 100
    },
    isAmountValid() {
      if (!this.payload.payment_system || !this.payload.amount) {
        return false;
      }

      const maxAmount = this.maxAmounts[this.payload.payment_system];
      const minAmount = this.minAmounts[this.payload.payment_system];

      return maxAmount && minAmount ?
          (this.payload.amount <= maxAmount && this.payload.amount >= minAmount) :
          true;
    },

    amountError() {
      if (!this.payload.payment_system || !this.payload.amount) {
        return '';
      }

      const maxAmount = this.maxAmounts[this.payload.payment_system];
      const minAmount = this.minAmounts[this.payload.payment_system];

      if (this.payload.amount > maxAmount) {
        return this.$t('exceedsMaxAmount');
      }
      if (this.payload.amount < minAmount) {
        return this.$t('belowMinAmount');
      }
      return '';
    }
  },
  created() {
    if (this.isLoadingCountryCode) {
      this.fetchPayments({countryCode: this.setting.countryCode});
    }
  },
  watch: {
    isLoadingCountryCode() {
      if (this.isLoadingCountryCode) {
        this.fetchPayments({countryCode: this.setting.countryCode});
      }
    }
  },
  methods: {
    ...mapActions('new_user',{
      setUuidAsync: 'setUuidAsync',
      isSafari: 'isSafari',
    }),
    ...mapActions('new_acquiring',{
      topUpBalanceStripeAsync: 'topUpBalanceStripeAsync',
      topUpBalanceBetaTransferAsync: 'topUpBalanceBetaTransferAsync',
    }),
    ...mapActions('gcf_store',{
      // Добавляем actions для GCF
      initGCFAsync: 'initGCFAsync',
      verifyGCFPaymentAsync: 'verifyGCFPaymentAsync',
      notifyWebhookAsync: 'notifyWebhookAsync',
    }),
    processPayment() {
      if(this.payload.type === 'refill_wallet' &&
          ['BetaTransferCrypto', 'BetaTransferUkraine', 'BetaTransferAZN', 'BetaTransferKZT'].includes(this.payload.payment_system)) {
        let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
        lang = lang === 'ru' ? 'rus' : 'eng'

        let payload = {
          success_url: `${window.location.origin}${this.$router.resolve({ name: 'personal'}).href}`,
          top_up_amount: this.payload.amount,
          payment_system: this.payload.payment_system
        }
        let headers = {
          auth: this.uuid,
          lang: lang,
        }
        this.topUpBalanceBetaTransferAsync({
          payload: payload,
          headers: headers,
        }).then((result) => {
          this.payload.amount = 0
          this.payload.type = 'refill_wallet'
          if (result.isSuccess) {
            window.open(result.pay_url, '_blank')
          } else {
            this.$toaster.error(result.exception.textError)
          }
        });
      }
      else if(this.payload.type === 'refill_wallet' && this.payload.payment_system === 'betatrans'){
        let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
        lang = lang === 'ru' ? 'rus' : 'eng'

        let payload = {
          success_url: `${window.location.origin}${this.$router.resolve({ name: 'personal'}).href}`,
          top_up_amount: this.payload.amount,
        }
        let headers = {
          auth: this.uuid,
          lang: lang,
        }
        this.topUpBalanceStripeAsync({
          payload:payload,
          headers:headers,
        }).then((result) => {
          this.payload.amount = 0
          this.payload.type = 'refill_wallet'
          if (result.isSuccess) {
            window.open(result.pay_url, '_blank')
          } else {
            this.$toaster.error(result.exception.textError)
          }
        });
      }
      else{
        if (this.isFutureFund) {
          this.payload.type = 'refill_future_wallet'
        }
        this.upBalance(this.payload)
            .then(() => {
              this.cashPopUpIframe(true);
            }).catch(error => {
          this.cashPopUpIframe(false);
          this.$toaster.error(error.response.data.error.message);
        })
      }
    },
    // Добавляем метод для инициализации GCF платежа
    initGCFPayment() {
      console.log(process.env.VUE_APP_NEW_API_URL);
      let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
      lang = lang === 'ru' ? 'rus' : 'eng';

      // Показываем индикатор загрузки
      this.$store.commit('gcf_store/SET_LOADING', true);

      const payload = {
        top_up_amount: this.payload.amount,
        payment_system: 'teido',
        wallet_type: this.isFutureFund ? 'futures' : 'main'
      };

      const headers = {
        Authorization: this.uuid,
        'X-Lang-Header': lang,
        'Content-Type': 'application/json'
      };

      // Создаем инвойс для GCF платежа
      axios.post(`${process.env.VUE_APP_NEW_API_URL}/api/teido/top-up-balance`, payload, {
        headers: headers
      }).then(response => {
        if (response.data.success) {
          // Успешное создание инвойса, подготавливаем данные для платежа
          this.gcfPaymentData = {
            amount: response.data.amount,
            currency: "USD",
            invoiceId: response.data.invoice_id,
            invoiceType: "topup",
            description: `Top up balance ${this.payload.amount} USD`,
            orderId: response.data.invoice_id,
            externalid: response.data.invoice_id,
            uuid: this.uuid,
            language: lang,
            billingInfo: {
              email: this.user.email || "",
              address: "",
              city: "",
              postcode: "",
              country: ""
            }
          };

          // Показываем компонент оплаты GCF
          this.showGCFPopup = true;
          this.$store.commit('gcf_store/SET_LOADING', false);
        } else {
          this.$store.commit('gcf_store/SET_LOADING', false);
          this.$toaster.error(response.data.error || 'Failed to prepare top-up');
        }
      }).catch(error => {
        this.$store.commit('gcf_store/SET_LOADING', false);
        // Формируем сообщение об ошибке
        var errorMessage = 'Error preparing top-up: ';
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage += error.response.data.error;
        } else {
          errorMessage += error.message;
        }
        this.$toaster.error(errorMessage);
      });
    },
    // Обработчики событий GCF платежа
    handleGCFPaymentSuccess(result) {
      console.log('GCF Payment success:', result);
      this.showGCFPopup = false;
      this.payload.amount = 0;

      // Уведомляем о успешном платеже
      this.notifyPaymentSuccess(result).then(() => {
        this.$toaster.success(this.$t('paymentSuccess'));
        this.fetchUser().then(() => {
          this.$router.push({ name: 'personal' });
        });
      }).catch(error => {
        console.error('Error notifying webhook:', error);
        // Даже при ошибке уведомления webhook мы все равно перенаправляем пользователя,
        // так как платеж уже совершен
        this.$toaster.success(this.$t('paymentSuccess'));
        this.fetchUser().then(() => {
          this.$router.push({ name: 'personal' });
        });
      });
    },

    handleGCFPaymentError(error) {
      console.error('GCF Payment error:', error);
      this.showGCFPopup = false;
      this.$toaster.error(error.textError || this.$t('paymentFailed'));
    },

    closeGCFPopup() {
      this.showGCFPopup = false;
    },

    // Уведомление о успешном платеже
    notifyPaymentSuccess(result) {
      let lang = store.state['vue-i18n-manager'].currentLanguage.translationKey;
      lang = lang === 'ru' ? 'rus' : 'eng';

      // Создаем данные для webhook
      const webhookData = {
        orderId: this.gcfPaymentData.invoiceId,
        status: 'success',
        externalid: this.gcfPaymentData.externalid,
        paymentResult: result
      };

      return axios.post(`${process.env.VUE_APP_NEW_API_URL}/teido/webhook`, webhookData, {
        headers: {
          'X-Lang-Header': lang,
          'Content-Type': 'application/json'
        }
      });
    },
    ...mapActions({
      fetchPayments: `profileBuyTree/${FETCH_PAYMENTS_SYSTEM}`,
      upBalance: `shop/${REPLENIST_BALANCE}`,
      fetchUser: `profile/LOAD_USER_DATA`,
    }),
    ...mapMutations({
      cashPopUpIframe: `shop/${POPUP_BUY_IFRAME}`,
    }),
    refillBalance() {
      // Проверка лимитов
      const maxAmount = this.maxAmounts[this.payload.payment_system];
      const minAmount = this.minAmounts[this.payload.payment_system];

      if (!this.payload.payment_system) {
        this.$toaster.error(this.$t('payMethod'));
        return false;
      }

      if (maxAmount && this.payload.amount > maxAmount) {
        this.$toaster.error(this.$t('exceedsMaxAmount'));
        return false;
      }

      if (minAmount && this.payload.amount < minAmount) {
        this.$toaster.error(this.$t('belowMinAmount'));
        return false;
      }

      // Проверяем, выбран ли GCFPay
      if (this.payload.payment_system === 'GCFPay') {
        this.initGCFPayment();
        return;
      }

      // Находим текущий способ оплаты
      let currentItemPayment = this.payments.find(e => e.payment_system === this.payload.payment_system);

      if (!currentItemPayment) {
        if (this.payload.payment_system === 'BetaTransferCrypto') {
          currentItemPayment = {
            payment_system: 'BetaTransferCrypto',
            restriction: null
          };
        } else if (this.payload.payment_system === 'BetaTransferUkraine') {
          currentItemPayment = {
            payment_system: 'BetaTransferUkraine',
            restriction: null
          };
        } else if (this.payload.payment_system === 'BetaTransferAZN') {
          currentItemPayment = {
            payment_system: 'BetaTransferAZN',
            restriction: null
          };
        } else if (this.payload.payment_system === 'BetaTransferKZT') {
          currentItemPayment = {
            payment_system: 'BetaTransferKZT',
            restriction: null
          };
        } else if (this.payload.payment_system === 'GCFPay') {
          currentItemPayment = {
            payment_system: 'GCFPay',
            restriction: null
          };
        }
      }

      if (this.payload.payment_system === 'BetaTransferCrypto') {
        this.showCryptoPopup = true;
      } else {
        this.processPayment();
      }
    },
    confirmCryptoPayment() {
      this.showCryptoPopup = false;
      this.processPayment();
    },

    closeCryptoPopup() {
      this.showCryptoPopup = false;
    },
  }
}